import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Dejé de sentirme perdido. Ahora sé qué hacer y cuándo hacerlo.',
  name: 'Laura M.',
  role: 'Hija y cuidadora'
}, {
  quote: 'Pasamos de discutir todo… a organizarnos mejor como familia.',
  name: 'Andrés R.',
  role: 'Hijo'
}, {
  quote: 'Lo que más me ayudó fue tener un sistema claro, no improvisar.',
  name: 'Carolina V.',
  role: 'Hija'
}];
export function Testimonials() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-274">
      <div className="max-w-xl mx-auto" data-id="element-275">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-276">
          💬 ¿Qué dicen las familias que ya usan el Megapack?
        </h2>

        <div className="space-y-4" data-id="element-277">
          {testimonials.map((t, i) => <div key={i} className="bg-gray-900 border border-gray-800 p-5 rounded-xl" data-id="element-278">
              <div className="flex gap-0.5 mb-3" data-id="element-279">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-brand-yellow text-brand-yellow" data-id="element-280" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-3 leading-relaxed" data-id="element-281">
                "{t.quote}"
              </p>
              <div data-id="element-282">
                <p className="font-bold text-white text-sm" data-id="element-283">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-284">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}